export const LOCAL_STORAGE_KEY = '__moveon_drop_dashboard_token__'
export const LOCAL_STORAGE_USER = '__moveon_drop_dashboard_user__'
export const LOCAL_STORAGE_WEBSITE_ID = '_drop_selected_website_id_'
